import { createContext, useContext, useState, type ReactNode } from 'react';

type MobileView = 'chat' | 'browse';

interface MobileViewContextType {
    mobileView: MobileView;
    setMobileView: (view: MobileView) => void;
}

const MobileViewContext = createContext<MobileViewContextType | undefined>(undefined);

interface MobileViewProviderProps {
    children: ReactNode;
}

export function MobileViewProvider({ children }: MobileViewProviderProps) {
    const [mobileView, setMobileView] = useState<MobileView>('browse');

    const value = {
        mobileView,
        setMobileView,
    };

    return (
        <MobileViewContext.Provider value={value}>
            {children}
        </MobileViewContext.Provider>
    );
}

export function useMobileView(): MobileViewContextType {
    const context = useContext(MobileViewContext);
    if (context === undefined) {
        throw new Error('useMobileView must be used within a MobileViewProvider');
    }
    return context;
}